import { FulfillmentOrderItemRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class FulfillmentOrderItemService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderItemRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default FulfillmentOrderItemService;
